document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
    const { productId, variant } = data;
    if (!productId || !variant) return;

    const cards = document.querySelectorAll(`[data-product-card][data-product-id="${productId}"]`);
    if (!cards.length) return;

    cards.forEach((card) => {
      const image = card.querySelector('[data-product-card-image]');
      const imageLink = card.querySelector('[data-product-card-link]');
      const titleLink = card.querySelector('[data-product-card-title-link]');
      const priceEl = card.querySelector('[data-product-card-price]');
      const comparePriceEl = card.querySelector('[data-product-card-compare-price]');

      if (image && variant.image) {
        // srcset would otherwise keep showing the previous variant's image
        image.removeAttribute('srcset');
        image.src = variant.image;
      }

      for (const link of [imageLink, titleLink]) {
        if (!link) continue;
        const url = new URL(link.href);
        url.searchParams.set('variant', variant.id);
        link.href = url.toString();
      }

      if (priceEl) {
        priceEl.textContent = variant.price_formatted;
      }

      if (comparePriceEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = variant.compare_at_price_formatted;
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.classList.add('hidden');
        }
      }
    });
  });
});
